module.exports = __webpack_public_path__ + "static/media/K.090eb130.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/K.jpg
// module id = 79
// module chunks = 0